import { render, staticRenderFns } from "./OpportunityResponse.vue?vue&type=template&id=2b38a029"
import script from "./OpportunityResponse.vue?vue&type=script&lang=js"
export * from "./OpportunityResponse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports